/* v2-teaser-landing.js — migrated out of sections/v2-teaser-landing.liquid's {% javascript %} block
   to avoid the local theme-dev compiled_assets/scripts.js truncation bug. */
(function () {
    function initCta(root) {
      if (!root) return;
      var cta = root.querySelector('.melee-date__cta');
      if (!cta || cta.dataset.meleeReady) return;
      cta.dataset.meleeReady = '1';

      var toggle = cta.querySelector('.melee-date__toggle');
      var input = cta.querySelector('.melee-date__input');
      var errorEl = cta.querySelector('.melee-date__error');
      var errorText = root.getAttribute('data-error-text') || 'Please enter a valid email address.';
      var genericError = 'Something went wrong. Please try again.';

      function open() {
        cta.classList.add('is-open');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        if (input)
          setTimeout(function () {
            input.focus();
          }, 380);
      }
      function close() {
        // collapse AND clear success / error so it returns to the plain button
        cta.classList.remove('is-open', 'is-done', 'is-error');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (typeof cta.reset === 'function') cta.reset();
      }
      function showError(msg) {
        if (errorEl) errorEl.textContent = msg;
        cta.classList.add('is-open', 'is-error');
        cta.classList.remove('is-done');
      }
      function clearError() {
        cta.classList.remove('is-error');
      }

      if (toggle) {
        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          if (!cta.classList.contains('is-open')) open();
        });
      }

      // empty / malformed email → styled message instead of the native bubble
      if (input) {
        input.addEventListener('invalid', function (e) {
          e.preventDefault();
          showError(errorText);
        });
        input.addEventListener('input', clearError);
      }

      // submit via fetch so the page never navigates away; confirm inline
      if (cta.tagName === 'FORM') {
        cta.addEventListener('submit', function (e) {
          e.preventDefault();
          if (input && !input.checkValidity()) {
            showError(errorText); // also covers browsers that skip the invalid event
            return;
          }
          clearError();
          var go = cta.querySelector('.melee-date__go');
          if (go) go.disabled = true;
          fetch(cta.action, {
            method: 'POST',
            body: new FormData(cta),
            headers: { Accept: 'text/html' },
          })
            .then(function () {
              cta.classList.remove('is-error');
              cta.classList.add('is-open', 'is-done');
            })
            .catch(function () {
              showError(genericError);
            })
            .then(function () {
              if (go) go.disabled = false;
            });
        });
      }

      // click outside / Escape collapses it back to the button (resetting a submit too)
      document.addEventListener('click', function (e) {
        if (cta.classList.contains('is-open') && !cta.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && cta.classList.contains('is-open')) close();
      });
    }

    function initAll() {
      document.querySelectorAll('.melee-date').forEach(initCta);
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);

    // Theme editor: re-init when this section is (re)loaded
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target;
      var md = el && el.classList && el.classList.contains('melee-date') ? el : el && el.querySelector('.melee-date');
      initCta(md);
    });
  })();
